import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

/** Thin accent bar under the header that fills as the page scrolls. */
export default function ScrollProgressBar() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 250, damping: 35, mass: 0.2 });

  return (
    <motion.div
      className="h-0.5 origin-left bg-gradient-to-r from-lc-pink via-lc-purple to-lc-orange"
      style={{ scaleX }}
    />
  );
}
